export default class FinalSelect{

	map = null;

	constructor( source ){

		this.source = source;
		this.map = new Map();

		this.root = document.createElement('div');
		this.root.classList.add('finalSelect');

		this.root.innerHTML = `<div class='finalSelectSelected'></div><div class='finalSelectOptions'></options>`;
		this.selected_container = new FinalSelectSelectedContainer( this.root.querySelector('.finalSelectSelected') );
		this.options_container = this.root.querySelector('.finalSelectOptions');

		this.#updateView();

		this.selected_container.update( [...this.map.keys().filter( (el) => el instanceof HTMLOptionElement && el.selected)], true );

		this.source.insertAdjacentElement('beforebegin', this.root)

		this.root.addEventListener('click', this);

	}


	handleEvent( e ){

		if( e.currentTarget === document ){

			this.root.classList.toggle('finalSelectActive');

			if( !this.root.classList.contains('finalSelectActive') ){
				document.removeEventListener('click', this );
			}

		} else if( e.currentTarget === this.root ){

			// This click triggered on `document` will open the select
			if( !this.root.classList.contains('finalSelectActive') )
				document.addEventListener('click', this );

		}

		// The document-targeted event only trigger open/close processes
		if( e.currentTarget !== document ){

			if( e.target.hasAttribute('data-value') ) {
				this.map.get(e.target).selected = true;
				this.selected_container.update( [...this.map.keys().filter( (el) => el instanceof HTMLOptionElement && el.selected)] );

				[...this.map.keys().filter( (el) => !(el instanceof HTMLOptionElement))]
					.map( (el) => el.classList.toggle('finalSelectOptionSelected', this.map.get(el).selected ))
			}

		}


		if( this.root.closest('label') )
			e.preventDefault();

	}

	#updateView( source ){

		if( this.map.size == 0 )
			this.#updateMap();

		[...this.map.keys()].map((back) => {

			let face = this.map.get(back);
			if( !face ){
				face = document.createElement('div');
				this.map.set(back, face);
				this.map.set(face, back);
			}

			let attrs = [];
			['hidden','selected','disabled'].map((attr) => {
				if( back.hasAttribute(attr) ){

					face.setAttribute(`data-${attr}`, '');

				} else {

					face.removeAttribute(`data-${attr}`);

				}
			})

			face.setAttribute(`data-value`, back.hasAttribute('value') ? back.value : back.innerHTML );
			face.innerHTML = back.innerHTML;

			this.options_container.append( face );

		});

		this.selected_container.update( [...this.map.keys().filter( (el) => el instanceof HTMLOptionElement && el.hasAttribute('selected') )] );
	}

	#updateMap(){

		[...this.source.querySelectorAll('option')].map((opt) => {

			if( !this.map.has(opt) )			
				this.map.set( opt, null )

		});

	}

}

class FinalSelectSelectedContainer{

	defaults = null;

	constructor( root ){
		this.root = root;
	}

	update( options, is_initial ){

		if( !this.defaults )
			this.defaults = options;
		this.root.innerHTML = options.map((opt) => `<div${is_initial ? " class='finalSelectSelectedInitial'" : ''}>${opt.innerHTML}</div>`).join('');
		
	}


}
